@if (startPointData()) {
  <div class="poi-wrapper" #poiWrapper>
    <div class="start-point">
      @if (startPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Icon) {
        <img
          class="map-btn-icon-wrapper icon"
          [src]="startPointData().icon | imageDimensions: { width: 50, height: 50 }"
        />
      }
      @if (startPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Image) {
        <img
          class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
          [src]="startPointData().image | imageDimensions: { height: 50 }"
        />
      }
      @if (startPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Name) {
        <span class="map-btn-name">{{ startPointData().name | localizedString }}</span>
      }

      <div class="start-point-marker">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_393_816)">
            <path
              d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0ZM12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92893C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.7612C17.6541 3.51808 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22Z"
              fill="#820B8A"
            />
            <path
              d="M18 12C18 15.3137 15.3137 18 12 18C8.6863 18 6.00001 15.3137 6.00001 12C6.00001 8.68629 8.6863 6 12 6C15.3137 6 18 8.68629 18 12Z"
              fill="#820B8A"
            />
          </g>
          <defs>
            <clipPath id="clip0_393_816"><rect width="24" height="24" fill="white" /></clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
}

@if (targetPointData()) {
  <div class="poi-wrapper" #poiWrapper>
    <div class="start-point">
      @if (targetPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Icon) {
        <img class="map-btn-icon-wrapper" [src]="targetPointData().icon | imageDimensions: { width: 50, height: 50 }" />
      }
      @if (targetPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Image) {
        <img
          class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
          [src]="targetPointData().image | imageDimensions: { height: 50 }"
        />
      }
      @if (targetPointData().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Name) {
        <span class="map-btn-name">{{ targetPointData().name | localizedString }}</span>
      }
      <div class="start-point-marker">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 1C8.3645 1 5 4.46964 5 8.73438C5 10.1753 5.38704 11.5815 6.11954 12.8015L12.0731 22.6953C12.1871 22.8848 12.388 23 12.6041 23H12.6091C12.827 22.9982 13.0284 22.8795 13.1403 22.6867L18.9421 12.697C19.6342 11.5028 20 10.1325 20 8.73438C20 4.46964 16.6355 1 12.5 1ZM17.8694 12.0351L12.5947 21.1174L7.18196 12.1223C6.57225 11.1069 6.24167 9.93535 6.24167 8.73438C6.24167 5.18043 9.05375 2.28047 12.5 2.28047C15.9462 2.28047 18.7542 5.18043 18.7542 8.73438C18.7542 9.89973 18.4454 11.0413 17.8694 12.0351Z"
            fill="#820B8A"
          />
          <path
            d="M12.5 5C10.5701 5 9 6.5701 9 8.5C9 10.4176 10.5445 12 12.5 12C14.4796 12 16 10.3965 16 8.5C16 6.5701 14.4299 5 12.5 5ZM12.5 10.8411C11.2067 10.8411 10.1589 9.78983 10.1589 8.5C10.1589 7.2134 11.2134 6.15889 12.5 6.15889C13.7866 6.15889 14.8372 7.2134 14.8372 8.5C14.8372 9.77101 13.8138 10.8411 12.5 10.8411Z"
            fill="#820B8A"
          />
        </svg>
      </div>
    </div>
  </div>
}

@if (floorplanDataItem()) {
  <div class="poi-wrapper" #poiWrapper>
    <div
      class="map-btn-container"
      [ngStyle]="{
        '--custom-rgb': convertRgbaToRgb(floorplanDataItem()?.qrCategoryColor),
        '--custom-rgba': floorplanDataItem()?.qrCategoryColor,
        '--custom-rgba-saturated': convertRgbaToRgb(floorplanDataItem()?.qrCategoryColor, 0.8),
        '--automatic-text-color': floorplanDataItem()?.qrCategoryColor
          ? getTextColorBasedOnBg(floorplanDataItem()?.qrCategoryColor)
          : '',
      }"
    >
      @if (!isActiveItem()) {
        @if (
          isDeploymentMode && qrCodeShowSettingsForDeploymentMode !== qrCodeShowOnFloorplanEnum.AccordingPoiSettings
        ) {
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CategoryIconName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CategoryIconCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CodeName) {
            <ng-container *ngTemplateOutlet="onlyName" />
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
        } @else {
          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }

          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.OnlyImage) {
            <ng-container *ngTemplateOutlet="onlyImage" />
          }

          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }

          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.ImageAndName) {
            <ng-container *ngTemplateOutlet="imageAndName" />
          }

          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.OnlyCategoryIcon) {
            <ng-container *ngTemplateOutlet="onlyCategoryIcon" />
          }

          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndImage) {
            <ng-container *ngTemplateOutlet="categoryIconAndImage" />
          }
          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (floorplanDataItem().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
        }
      } @else {
        @if (
          isDeploymentMode && qrCodeShowSettingsForDeploymentMode !== qrCodeShowOnFloorplanEnum.AccordingPoiSettings
        ) {
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CategoryIconName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CategoryIconCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode === qrCodeShowOnFloorplanEnum.CodeName) {
            <ng-container *ngTemplateOutlet="onlyName" />
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
        } @else {
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndImage) {
            <ng-container *ngTemplateOutlet="categoryIconAndImage" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.ImageAndName) {
            <ng-container *ngTemplateOutlet="imageAndName" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.OnlyCategoryIcon) {
            <ng-container *ngTemplateOutlet="onlyCategoryIcon" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.OnlyImage) {
            <ng-container *ngTemplateOutlet="onlyImage" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (floorplanDataItem().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
        }
      }
    </div>
  </div>
  <!--    TEMPLATES-->
  <ng-template #onlyName>
    <div class="poi onlyName">
      <span class="map-btn-name">{{
        (floorplanDataItem().mapName | localizedString) || (floorplanDataItem.name! | localizedString)
      }}</span>
    </div>
  </ng-template>
  <ng-template #onlyImage>
    <div class="poi onlyImage">
      <img class="map-btn-icon-wrapper" [src]="floorplanDataItem()?.linkToImage | imageDimensions: { height: 50 }" />
    </div>
  </ng-template>
  <ng-template #onlyCategoryIcon>
    <div class="poi onlyCategoryIcon">
      @if (floorplanDataItem().linkToIcon) {
        <cue-icon [icon]="floorplanDataItem()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
        <cue-icon [id]="generatedDomId" class="tempHidden" [icon]="ICONS.cueQrCode" />
      } @else {
        <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
      }
    </div>
  </ng-template>
  <ng-template #imageAndName>
    <div class="poi imageAndName">
      <span class="map-btn-name">{{
        (floorplanDataItem().mapName | localizedString) || (floorplanDataItem.name! | localizedString)
      }}</span>
      <img class="map-btn-icon-wrapper" [src]="floorplanDataItem()?.linkToImage | imageDimensions: { height: 50 }" />
    </div>
  </ng-template>

  <ng-template #categoryIconAndName>
    <div class="poi categoryIconAndName">
      <span class="map-btn-name">{{
        (floorplanDataItem().mapName | localizedString) || (floorplanDataItem().name! | localizedString)
      }}</span>
      @if (floorplanDataItem().linkToIcon) {
        <cue-icon [icon]="floorplanDataItem()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
      } @else {
        <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
      }
    </div>
  </ng-template>
  <ng-template #categoryIconAndImage>
    <div class="poi categoryIconAndImage">
      <img
        class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
        [src]="floorplanDataItem()?.linkToImage | imageDimensions: { width: 50, height: 50 }"
      />
      @if (floorplanDataItem().linkToIcon) {
        <cue-icon [icon]="floorplanDataItem()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
      } @else {
        <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
      }
    </div>
  </ng-template>

  <ng-template #onlyCode>
    <div class="poi onlyCode">
      <span class="map-btn-name">{{ floorplanDataItem().qrCode }}</span>
    </div>
  </ng-template>

  <ng-template #categoryIconAndCode>
    <div class="poi categoryIconAndName">
      <span class="map-btn-name">{{ floorplanDataItem().qrCode }}</span>
      @if (floorplanDataItem().linkToIcon) {
        <cue-icon [icon]="floorplanDataItem()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
      } @else {
        <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
      }
    </div>
  </ng-template>
}
